export default "data:image/gif;base64,R0lGODlhCAAIAIABAOvr6wAAACH5BAEKAAEALAAAAAAIAAgAAAIPRAKGe3zZjJLyORjbmrMAADs="